import gql from "graphql-tag"

const AllCarInspections = gql`query AllCarInspections($searchTerm: String, $orderBy: [String], $filters: [FilterInput], $first: Int, $cursor: String){
    allCarConditions(first: $first, after: $cursor, orderBy: $orderBy, searchTerm: $searchTerm, filters: $filters){
        edges {
            node {
                id
                pk
                dateAdded
                formType
                sourceDisplay
                mileage
                pictureCount
                previewPictures
                hasIncidents
                cancellationReason
                car {
                    id
                    pk
                    year
                    carModel {
                        id
                        make
                        name
                    }
                    branch {
                        id
                        name
                    }
                }
                rental {
                    id
                    driver {
                        id
                        name
                    }
                }
                user {
                    id
                    username
                    firstName
                    lastName
                }
            }
        }
        pageInfo {
            hasNextPage
            startCursor
            endCursor
        }
    }
}`

// Loaded only when the pictures modal opens, so the listing never pulls every
// row's pictures.
const CarInspectionPictures = gql`query CarInspectionPictures($carConditionId: ID!){
    carCondition(carConditionId: $carConditionId){
        id
        carpicturesSet {
            edges {
                node {
                    id
                    pictureUrl
                    pictureType
                    pictureTypeDisplay
                    description
                    dateAdded
                }
            }
        }
    }
}`

export { AllCarInspections, CarInspectionPictures }
